import{
    apiRequest,
    legalDetail,
    legalUpdate,
} from "../../../../../services/adapters/master/legalService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", legalDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", legalUpdate, {
            body: query
        }, true)
    }

}

export default UpdateRepository